import { useMemo } from 'react'

import { useGetSenderIds } from './use-get-sender-ids'

export const useGetWhatsappSenderOptions = () => {
  const result = useGetSenderIds()

  const senderIds = useMemo(() => {
    const data = result.data
    const source = Array.isArray(data) ? data : data?.whatsapp || []

    return source.map(({ phonenumber, sender, name }) => ({
      label: name ? `${name} (${sender || phonenumber})` : sender || phonenumber,
      value: sender || phonenumber,
    }))
  }, [result.data])

  return {
    senderIds,
    isLoading: result.isLoading,
  }
}
